import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthorizedUserFeaturesContainerComponent } from './authorized-user-features-container/authorized-user-features-container.component';
import { RouterModule } from '@angular/router';
import { SessionsSharedModule, UserFeaturesModule } from '@modules';
import { VideoCallModule } from '../modules/video-call/video-call.module';
import { CloseRequisitionsModule } from '@features/modules';
import { ModalSaudeIdMarketplaceModule } from 'src/app/project/components/modal-saudeId-marketplace/modal-saudeId-marketplace.module';
import { ModalQrCodeModule } from '../../project/components/modal-qr-code/modal-qr-code.module';
import { ModalCnesModule } from '../../project/components/modal-cnes/modal-cnes.module';
import { ModalPatientsHistoryConsultationModule } from '../../project/components/modal-patients-history-consultation/modal-patients-history-consultation.module';
import { ModalStartAppointmentModule } from '../../lazy-modules/appointment-management/start-appointment-modal/start-appointment-modal.module';
import { ModalSendDocumentsModule } from '../../project/components/modal-send-documents/modal-send-documents.module';
import { ModalRescheduleOptionsModule } from '../../lazy-modules/appointment-management/rescheduling-options/modal-rescheduling-options.module';
import { ModalPhysicianSignatureValidationModule } from '../../project/components/modal-physician-signature-validation/modal-physician-signature-validation.module';

@NgModule({
  declarations: [AuthorizedUserFeaturesContainerComponent],
  imports: [
    CommonModule,
    RouterModule,
    UserFeaturesModule,
    VideoCallModule.forRoot(),
    CloseRequisitionsModule,
    SessionsSharedModule.forRoot(),
    ModalSaudeIdMarketplaceModule,
    ModalQrCodeModule,
    ModalCnesModule,
    ModalStartAppointmentModule,
    ModalRescheduleOptionsModule,
    ModalPatientsHistoryConsultationModule,
    ModalSendDocumentsModule,
    ModalPhysicianSignatureValidationModule,
  ],
})
export class AuthorizedUserFeaturesContainerModule {}
